import {Observable, Subscription} from 'rxjs';

import IPlaybackQuality from '../../../../Solutions/Shared/Interfaces/IPlaybackQuality';
import IPlaybackStore   from '../Interfaces/IPlaybackStore';

const subscribeToPlaybackQuality = (
    playbackQuality$: Observable<IPlaybackQuality>,
    playbackStore: IPlaybackStore
): Subscription =>
    playbackQuality$
        .subscribe(playbackQuality => playbackStore.actions.updatePlaybackQuality(playbackQuality));

export default subscribeToPlaybackQuality;